import { render, staticRenderFns } from "./account-classification.vue?vue&type=template&id=c7a713a8&"
import script from "./account-classification.vue?vue&type=script&lang=js&"
export * from "./account-classification.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports